//Core
import React from "react"

//Components
import Seo from "../../container/Layout/Seo"
import SimpleFooter from "../../container/Layout/SimpleFooter"
import CashNowCPA from "../../modules/watermeloncpa"

//Styles
import "../../styles/main.scss"
import "./index.css"

const CashNowpage = () => (
  <>
    <Seo
      title={`Швидкий кредит готівкою | ТАСКОМБАНК`}
      description={`Оформлюйте кредит за лічені хвилини на будь-які потреби`}
      link={`https://tascombank.ua/promo/cashnowatm`}
    ></Seo>
    <CashNowCPA></CashNowCPA>
  </>
)

export default CashNowpage
